export function searchActivate() {
    document.querySelector('.post-slider__search-button').addEventListener('click', (e) => {
        e.preventDefault();
        e.currentTarget.classList.toggle('post-slider__search-button--active');
        document.querySelector('.post-slider__search').classList.toggle('post-slider__search--active');
    });
}